// Rule for expiry dates on credit cards ex: 12/2025
import { findRule } from '../Utils';

const months = /^(0[1-9]|1[0-2])\/\d{4}$/;

const validate = (vObj) => {
  const { value } = vObj;
  const rule = findRule(vObj.errorBag, 'monthYear');
  rule.feedback = `${vObj.fieldlabel} should be in MM/YYYY format`;

  const testValue = (val) => {
    const strValue = String(val);

    return months.test(strValue);
  };

  if (Array.isArray(value)) {
    return value.every(testValue);
  }

  return testValue(value);
};

export { validate };

export default {
  validate,
};
